import { Routes, Route, Navigate } from 'react-router-dom';
import EmployeeLayout from '../components/employee/EmployeeLayout.jsx';
import ExpenseApprovalQueuePage from './approver/ExpenseApprovalQueuePage.jsx';
import ExpenseApprovalHistoryPage from './approver/ExpenseApprovalHistoryPage.jsx';
import ReviewExpenseReportPage from './approver/ReviewExpenseReportPage.jsx';

export default function ExpenseApproverPage() {
  return (
    <Routes>
      <Route element={<EmployeeLayout />}>
        <Route index element={<ExpenseApprovalQueuePage />} />
        <Route path="history" element={<ExpenseApprovalHistoryPage />} />
        <Route path=":userId/:reportId" element={<ReviewExpenseReportPage />} />
        <Route path="*" element={<Navigate to="/expense-approvals" replace />} />
      </Route>
    </Routes>
  );
}
